import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: [],
  },
  action
) {
  switch (action.type) {
    case homeConstants.PRODUCTS_LIST_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.PRODUCTS_LIST_SUCCESS:
      return {
        ...state,
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.PRODUCTS_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        data: [],
        isProgress: false,
      };
    default:
      return state;
  }
}
